import * as React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { MarkdownCopy } from '../../../../components/MarkdownCopy';
const StyledMarkDown = styled(MarkdownCopy)`
  ${({
  disclosure
}) => disclosure ? `font-size:14px` : null}
`;
export const BodyCopy = ({
  className,
  body,
  disclosure = false
}) => /*#__PURE__*/React.createElement(StyledMarkDown, {
  className: cn(className, {
    bodyCopyType_disclosure: disclosure
  }),
  disclosure: disclosure,
  source: body || ''
});